import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
    class: "tab-content",
    id: "couponTabsContent"
};
const _hoisted_5 = {
    class: "tab-pane fade show active",
    id: "general",
    role: "tabpanel"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "form-group mb-20" };
const _hoisted_9 = { class: "col-md-6" };
const _hoisted_10 = { class: "form-group mb-20" };
const _hoisted_11 = { class: "col-md-12" };
const _hoisted_12 = { class: "form-group mb-20" };
const _hoisted_13 = { class: "input-group" };
const _hoisted_14 = { class: "col-md-6" };
const _hoisted_15 = { class: "form-group mb-20" };
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "form-group mb-20" };
const _hoisted_18 = { class: "col-md-12" };
const _hoisted_19 = { class: "form-group mb-20" };
const _hoisted_20 = {
    class: "tab-pane fade",
    id: "restrictions",
    role: "tabpanel"
};
const _hoisted_21 = { class: "row" };
const _hoisted_22 = { class: "col-md-6" };
const _hoisted_23 = { class: "form-group mb-20" };
const _hoisted_24 = { class: "col-md-6" };
const _hoisted_25 = { class: "form-group mb-20" };
const _hoisted_26 = { class: "col-md-6" };
const _hoisted_27 = { class: "form-group mb-20" };
const _hoisted_28 = { class: "col-md-6" };
const _hoisted_29 = { class: "form-group mb-20" };
const _hoisted_30 = { class: "col-md-6" };
const _hoisted_31 = { class: "form-group mb-20" };
const _hoisted_32 = { class: "col-md-6" };
const _hoisted_33 = { class: "form-group mb-20" };
const _hoisted_34 = { class: "col-md-6" };
const _hoisted_35 = { class: "form-group mb-20" };
const _hoisted_36 = { class: "col-md-6" };
const _hoisted_37 = { class: "form-group mb-20" };
const _hoisted_38 = {
    class: "tab-pane fade",
    id: "advanced",
    role: "tabpanel"
};
const _hoisted_39 = { class: "row" };
const _hoisted_40 = { class: "col-md-6" };
const _hoisted_41 = { class: "form-group mb-15" };
const _hoisted_42 = { class: "form-check form-switch" };
const _hoisted_43 = { class: "col-md-6" };
const _hoisted_44 = { class: "form-group mb-15" };
const _hoisted_45 = { class: "form-check form-switch" };
const _hoisted_46 = { class: "col-md-6" };
const _hoisted_47 = { class: "form-group mb-15" };
const _hoisted_48 = { class: "form-check form-switch" };
const _hoisted_49 = { class: "col-md-6" };
const _hoisted_50 = { class: "form-group mb-15" };
const _hoisted_51 = { class: "form-check form-switch" };
const _hoisted_52 = { class: "col-md-6" };
const _hoisted_53 = { class: "form-group mb-15" };
const _hoisted_54 = { class: "form-check form-switch" };
const _hoisted_55 = {
    key: 0,
    class: "col-md-12 mt-20"
};
const _hoisted_56 = { class: "form-group mb-15" };
const _hoisted_57 = {
    key: 0,
    class: "col-md-12 mt-30"
};
const _hoisted_58 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_59 = {
    key: 1,
    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-16 bg-success",
    type: "submit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[51] || (_cache[51] = _createElementVNode("ul", {
                class: "nav nav-tabs mb-25 border-bottom-0",
                id: "couponTabs",
                role: "tablist"
            }, [
                _createElementVNode("li", {
                    class: "nav-item",
                    role: "presentation"
                }, [
                    _createElementVNode("button", {
                        class: "nav-link active fw-semibold",
                        id: "general-tab",
                        "data-bs-toggle": "tab",
                        "data-bs-target": "#general",
                        type: "button",
                        role: "tab"
                    }, "Général")
                ]),
                _createElementVNode("li", {
                    class: "nav-item",
                    role: "presentation"
                }, [
                    _createElementVNode("button", {
                        class: "nav-link fw-semibold",
                        id: "restrictions-tab",
                        "data-bs-toggle": "tab",
                        "data-bs-target": "#restrictions",
                        type: "button",
                        role: "tab"
                    }, "Restrictions & Dates")
                ]),
                _createElementVNode("li", {
                    class: "nav-item",
                    role: "presentation"
                }, [
                    _createElementVNode("button", {
                        class: "nav-link fw-semibold",
                        id: "advanced-tab",
                        "data-bs-toggle": "tab",
                        "data-bs-target": "#advanced",
                        type: "button",
                        role: "tab"
                    }, "Ciblage & Avancé")
                ])
            ], -1)),
            _createElementVNode("form", {
                onSubmit: _cache[22] || (_cache[22] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.saveCoupon && _ctx.saveCoupon(...args)), ["prevent"]))
            }, [
                _createElementVNode("fieldset", { disabled: _ctx.isReadOnly }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mode de l'avantage *", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.mode,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.couponData.mode) = $event)),
                                            options: Array.isArray(_ctx.modes) ? _ctx.modes : [],
                                            label: "label",
                                            reduce: m => m.value,
                                            placeholder: "Choisir le mode",
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "reduce", "disabled"]),
                                        _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Code = Public (ex: BIENVENUE), Coupon = Unique/Personnel.", -1))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type de réduction *", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.discount_type,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.couponData.discount_type) = $event)),
                                            options: Array.isArray(_ctx.discountTypes) ? _ctx.discountTypes : [],
                                            label: "label",
                                            reduce: t => t.value,
                                            placeholder: "Selectionner le type",
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Code Promo / Préfixe *", -1)),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black text-uppercase",
                                                style: { "border-left": "1px solid #dee2e6" },
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.couponData.code) = $event)),
                                                placeholder: "E.g. WELCOME10",
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _ctx.couponData.code]
                                            ]),
                                            (!_ctx.isReadOnly)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "btn btn-outline-secondary rounded-0",
                                                    onClick: _cache[3] || (_cache[3] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.generateCode && _ctx.generateCode(...args)))
                                                }, [...(_cache[26] || (_cache[26] = [
                                                        _createElementVNode("i", { class: "flaticon-refresh" }, null, -1),
                                                        _createTextVNode(" Générer ", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Valeur de la réduction *", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            step: "0.01",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.couponData.discount_value) = $event)),
                                            required: ""
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.discount_value]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Limite d'utilisation totale", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.couponData.usage_limit) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.usage_limit]
                                        ]),
                                        _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Nb total de fois où ce code peut être utilisé (0 ou vide = infini).", -1))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1)),
                                        _withDirectives(_createElementVNode("textarea", {
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.couponData.description) = $event)),
                                            rows: "2"
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.description]
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Valide du", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "datetime-local",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.couponData.valid_from) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.valid_from]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Jusqu'au", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "datetime-local",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.couponData.valid_until) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.valid_until]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant Min. Commande", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            step: "0.01",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.couponData.min_order_amount) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.min_order_amount]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Réduction Max (€)", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            step: "0.01",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.couponData.max_discount_amount) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.couponData.max_discount_amount]
                                        ]),
                                        _cache[36] || (_cache[36] = _createElementVNode("small", { class: "text-muted" }, "Si pourcentage, plafonne la remise.", -1))
                                    ])
                                ]),
                                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-12" }, [
                                    _createElementVNode("hr", { class: "my-3" }),
                                    _createElementVNode("h6", { class: "mb-15" }, "Restrictions d'éligibilité")
                                ], -1)),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Restaurants autorisés", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.allowed_restaurants,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.couponData.allowed_restaurants) = $event)),
                                            options: Array.isArray(_ctx.restaurants) ? _ctx.restaurants : [],
                                            label: "name",
                                            reduce: r => r.id,
                                            multiple: "",
                                            placeholder: "Tous par défaut",
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Zones de livraison (Codes postaux)", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.allowed_zones,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.couponData.allowed_zones) = $event)),
                                            options: Array.isArray(_ctx.postalCodes) ? _ctx.postalCodes : [],
                                            label: "label",
                                            reduce: z => z.code,
                                            multiple: "",
                                            placeholder: "Toutes par défaut",
                                            loading: _ctx.isZonesLoading,
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "reduce", "loading", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Canaux", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.allowed_channels,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.couponData.allowed_channels) = $event)),
                                            options: Array.isArray(_ctx.channels) ? _ctx.channels : [],
                                            multiple: "",
                                            placeholder: "Tous par défaut",
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _cache[40] || (_cache[40] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Méthodes de commande", -1)),
                                        _createVNode(_component_v_select, {
                                            modelValue: _ctx.couponData.allowed_order_methods,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.couponData.allowed_order_methods) = $event)),
                                            options: Array.isArray(_ctx.orderMethods) ? _ctx.orderMethods : [],
                                            label: "label",
                                            reduce: m => m.value,
                                            multiple: "",
                                            placeholder: "Toutes par défaut",
                                            disabled: _ctx.isReadOnly
                                        }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.couponData.is_template) = $event)),
                                                id: "isTemplate"
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.couponData.is_template]
                                            ]),
                                            _cache[42] || (_cache[42] = _createElementVNode("label", {
                                                class: "form-check-label fw-semibold",
                                                for: "isTemplate"
                                            }, "Définir comme modèle (Template)", -1))
                                        ]),
                                        _cache[43] || (_cache[43] = _createElementVNode("small", { class: "text-muted d-block" }, "Utilisable pour les anniversaires ou incidents.", -1))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.couponData.is_first_order_only) = $event)),
                                                id: "firstOrderOnly"
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.couponData.is_first_order_only]
                                            ]),
                                            _cache[44] || (_cache[44] = _createElementVNode("label", {
                                                class: "form-check-label fw-semibold",
                                                for: "firstOrderOnly"
                                            }, "Première commande uniquement", -1))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.couponData.is_account_required) = $event)),
                                                id: "accRequired"
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.couponData.is_account_required]
                                            ]),
                                            _cache[45] || (_cache[45] = _createElementVNode("label", {
                                                class: "form-check-label fw-semibold",
                                                for: "accRequired"
                                            }, "Compte client requis", -1))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.couponData.is_stackable) = $event)),
                                                id: "isStackable"
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.couponData.is_stackable]
                                            ]),
                                            _cache[46] || (_cache[46] = _createElementVNode("label", {
                                                class: "form-check-label fw-semibold",
                                                for: "isStackable"
                                            }, "Cumulable avec d'autres codes", -1))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.couponData.can_go_below_min_delivery_fee) = $event)),
                                                id: "minDelivery"
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.couponData.can_go_below_min_delivery_fee]
                                            ]),
                                            _cache[47] || (_cache[47] = _createElementVNode("label", {
                                                class: "form-check-label fw-semibold",
                                                for: "minDelivery"
                                            }, "Peut descendre sous le min. livraison", -1))
                                        ])
                                    ])
                                ]),
                                (_ctx.actionDetected === 'add')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _cache[50] || (_cache[50] = _createElementVNode("h6", { class: "mb-15" }, "Génération en masse", -1)),
                                        _createElementVNode("div", _hoisted_56, [
                                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantité à générer", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control shadow-none rounded-0 text-black w-25",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.batchQuantity) = $event)),
                                                min: "1"
                                            }, null, 512), [
                                                [_vModelText, _ctx.batchQuantity]
                                            ]),
                                            _cache[49] || (_cache[49] = _createElementVNode("small", { class: "text-muted" }, "Laissez à 1 pour un seul code.", -1))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ], 8, _hoisted_3),
                (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                : (_openBlock(), _createElementBlock("button", _hoisted_59, _toDisplayString(_ctx.actionDetected === 'edit' ? 'Mettre à jour' : (_ctx.batchQuantity > 1 ? 'Lancer la génération (' + _ctx.batchQuantity + ')' : 'Créer le coupon')), 1)),
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[21] || (_cache[21] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "bg-transparent p-0 border-0 text-danger fw-medium"
                            }, " Annuler ")
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 32)
        ])
    ]));
}
